import { BiLeaf } from 'react-icons/bi';
import { FiChevronRight } from 'react-icons/fi';
import Stack from 'components/Stack';
import Tooltip from 'components/Tooltip';
import styled from 'styled-components';

const IconWrapper = styled.span`
    margin-right: ${({ theme }) => theme.space_4}px;
    color: ${({ theme }) => theme.gray_4};
    display: inline-flex;
    align-self: center;
`;

const FlavorsCell = ({ item }) => {
    const flavorsCellText = item?.flavors
        ?.map(([_, hierarchy]) => hierarchy?.cat4)
        .join(', ');

    return (
        <Tooltip
            content={
                <>
                    <Stack
                        $direction="row"
                        $wrap={false}
                        css={`
                            align-items: center;
                            font-size: 16px;
                            color: white;
                            font-weight: 500;
                        `}
                    >
                        <IconWrapper>
                            <BiLeaf
                                style={{
                                    minWidth: '1.25em',
                                    height: '1.25em',
                                }}
                            />
                        </IconWrapper>
                        <span>Flavors</span>
                    </Stack>
                    {item?.flavors?.map(([id, { cat2, cat3, cat4 }]) => (
                        <Stack
                            $space="4px"
                            $direction="row"
                            $wrap={false}
                            css={`
                                font-family: ${({ theme }) =>
                                    theme.style_primary};
                                text-transform: capitalize;
                                font-size: 14px;
                                color: white;
                                font-weight: 400;
                            `}
                        >
                            <span>{cat2}</span>
                            <FiChevronRight
                                style={{
                                    minWidth: '1.25em',
                                    height: '1.25em',
                                }}
                            />
                            <span>{cat3}</span>
                            <FiChevronRight
                                style={{
                                    minWidth: '1.25em',
                                    height: '1.25em',
                                }}
                            />
                            <span>{cat4}</span>
                        </Stack>
                    ))}
                </>
            }
            mixpanelMeta={{ contentKey: 'flavors' }}
            width={'fit-content'}
            showTimeout={300}
        >
            <span
                css={`
                    font-size: 0.875rem;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: break-spaces;
                    text-transform: capitalize;
                    text-align: left;
                `}
            >
                {flavorsCellText || '\u2013'}
            </span>
        </Tooltip>
    );
};

export default FlavorsCell;
